module.exports = __webpack_public_path__ + "img/ticket.8ec06e08.svg";